<template>
  <div>
    <div>
      <v-row justify="space-between" align="center">
        <v-col cols="10"
          ><h2 class="ml-10 my-5">{{ $t("dashboard") }}</h2></v-col
        >
        <v-col cols="1">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="200"
            left
            min-width="500"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-cog-outline </v-icon>
              </v-btn>
            </template>

            <v-card width="500">
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="6">
                      <v-checkbox
                        v-model="genotypeChecked"
                        :label="this.$t('dashboardS.performanceOfGeno')"
                        color="primary"
                        hide-details
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6">
                      <v-checkbox
                        v-model="conceptionChecked"
                        :label="this.$t('animal.conception')"
                        color="primary"
                        hide-details
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6">
                      <v-checkbox
                        v-model="embryoInfoChecked"
                        :label="this.$t('dashboardS.semEmbInfo')"
                        color="primary"
                        hide-details
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-layout justify-center>
                <v-card-actions class="mb-5">
                  <v-spacer></v-spacer>
                  <v-btn
                    outlined
                    color="primary"
                    @click="restoreDefaualtStructure"
                    width="fit-content"
                  >
                    {{ $t("restoreDefault") }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    width="190"
                    @click="resetCardStructure"
                  >
                    {{ $t("apply") }}
                  </v-btn>
                </v-card-actions>
              </v-layout>
            </v-card>
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="mt-10 px-9">
        <v-col cols="12" sm="6" md="6">
          <v-card rounded class=" border" outlined>
            <v-card-text class="pa-0">
              <v-list
                subheader
                three-line
              >
                <v-list-item class="mt-n11">
                  <v-list-item-avatar size="70" color="#e6fff5">
                    <v-icon color="primary">mdi-pulse</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                      {{ activitiesCount }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="mt-n3 font-weight-medium">
                      {{ $t("dashboardS.dailyActivities") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="$router.push({name: 'ActivityLog'})">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
              </v-list-item-action>
            </v-list-item>
              </v-list>
            </v-card-text>
            
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-card class=" border" outlined>
            <v-card-text class="pa-0">
              <v-list
                subheader
                three-line
              >
                <v-list-item class="mt-n11">
                  <v-list-item-avatar size="70" color="#e6fff5">
                    <v-icon color="primary">mdi-text-box-outline</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                      {{ pendingTasksCount }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="mt-n3 font-weight-medium">
                      {{ $t("dashboardS.pendingTasks") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="$router.push({name: 'DailyTask'})">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
              </v-list-item-action>
            </v-list-item>
              </v-list>
            </v-card-text>
            
          </v-card>
        </v-col>
      </v-row>
      <v-card
        class="border rounded-lg mx-9 mt-5"
        elevation="0"
        outlined
        id="genoTypeTable"
        v-show="performanceOfGenotypes"
      >
        <!-- <v-card-title>
          Performance of Genotype
          <v-spacer></v-spacer>
          <v-avatar size="15" color="#DAE1EC"></v-avatar>
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on">
                <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-card-title> -->
        <!--------------------- Tablet Screen For GenoTypes---------------------->
        <!------------------- Start -------------------->
        <v-card v-if="checkBreakPoints" elevation="0" class="px-5">
          <div class="d-flex my-5">
            <p class="mt-2 ml-4">{{ $t("dashboardS.performanceOfGeno") }}</p>
            <v-spacer></v-spacer>
            <div class="py-1 title">
              {{ fromGenotype }} - {{ toGenotype }} of {{ totalgenos }}
            </div>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="tabletTableOptionsGenotype.page <= 1"
              @click="tabletPageChangeGenoType(false)"
            >
              <v-icon dark> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="tabletTableOptionsGenotype.page >= totalPagesGenotype"
              @click="tabletPageChangeGenoType(true)"
            >
              <v-icon dark> mdi-chevron-right </v-icon>
            </v-btn>
          </div>
          <v-card
            v-for="(item, index) in itemsForGenotype"
            :key="index"
            class="inner-card my-4 py-2 px-4"
            :elevation="0"
            :style="
              index % 2 !== 0 && {
                backgroundColor: 'rgba(243, 243, 243, 0.5)',
              }
            "
          >
            <v-row no-gutters class="my-5">
              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("actionListmod.bREED")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.breedName
                }}</v-card-text>
              </v-col>

              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("dashboardS.chromosome")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.chromosome
                }}</v-card-text>
              </v-col>

              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("dashboardS.seqChange")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.sequenceChange
                }}</v-card-text>
              </v-col>
              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("dashboardS.inheritance")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.inheritance
                }}</v-card-text>
              </v-col>
              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("dashboardS.diseaseName")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.diseaseName
                }}</v-card-text>
              </v-col>
              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("dashboardS.refSequence")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.referenceSequence
                }}</v-card-text>
              </v-col>
              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  "dashboardS.pubmedRef"
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.pubmedReference
                }}</v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
        <!-----------------End --------------------->
        <v-data-table
          v-else
          v-model="selected"
          :headers="headersForGenotype"
          :items="indexedItems(itemsForGenotype)"
          :items-per-page="5"
          hide-default-footer
          :options.sync="tableOptionsGenotype"
          item-key="id"
          :server-items-length="totalgenos"
          :loading="ploading"
        >
          <template v-slot:top>
            <div class="d-flex my-5">
              <p class="mt-2 ml-4 font-weight-bold">
                {{ $t("dashboardS.performanceOfGeno") }}
              </p>
              <v-spacer></v-spacer>
              <div class="py-1 title">
                {{ fromGenotype }} - {{ toGenotype }} of {{ totalgenos }}
              </div>
              <v-btn
                class="mt-1 ml-1"
                icon
                :disabled="tableOptionsGenotype.page <= 1"
                @click="pageChangeGenoType(false)"
              >
                <v-icon small> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn
                class="mt-1"
                icon
                :disabled="tableOptionsGenotype.page >= totalPagesGenotype"
                @click="pageChangeGenoType(true)"
              >
                <v-icon small> mdi-chevron-right </v-icon>
              </v-btn>
              <!-- <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="mt-1 mr-1">
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
              </v-menu> -->
            </div>
          </template>

          <!-- <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th 
                  v-for="item in headers" 
                  :key="item.value"
                  v-bind:class="[item.sortable ? 'sortable' : '', tableOptionsGenotype.sortBy[0] == item.value ? 'active': '', tableOptionsGenotype.descending ? 'desc':'asc', item.class, 'my-class']"
                  @click="item.sortable ? changeSort(item.value, 'tableOptionsGenotype') : ''"
                >
                  <v-checkbox
                    v-if="item.value=='data-table-select'"
                    multiple
                    v-model="selected"
                    :value="item"
                    style="margin: 0px; padding: 0px"
                    hide-details
                    v-on:click.stop=""
                  />
                  <span v-else>{{ item.text }}
                  <v-icon  v-if="item.sortable" small>mdi-unfold-more-horizontal</v-icon></span>
                </th>
              </tr>  
            </thead>
          </template> -->
        </v-data-table>
      </v-card>
      <v-card
        class="border rounded-lg mx-9 my-5"
        elevation="0"
        outlined
        id="conceptionTable"
        v-show="conception"
      >
        <!-- <v-card-title>
          Conception
          <v-spacer></v-spacer>
          <v-avatar size="15" color="#DAE1EC"></v-avatar>
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on">
                <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-card-title> -->
        <!--------------------- Tablet Screen For Conception---------------------->
        <!------------------- Start -------------------->
        <v-card v-if="checkBreakPoints" elevation="0" class="px-5">
          <div class="d-flex my-5">
            <p class="mt-2 ml-4">{{ $t("animal.conception") }}</p>
            <v-spacer></v-spacer>
            <div class="py-1 title">
              {{ fromConception }} - {{ toConception }} of
              {{ totalConception }}
            </div>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="tabletTableOptionsConception.page <= 1"
              @click="tabletPageChangeConception(false)"
            >
              <v-icon dark> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="
                tabletTableOptionsConception.page >= totalPagesConception
              "
              @click="tabletPageChangeConception(true)"
            >
              <v-icon dark> mdi-chevron-right </v-icon>
            </v-btn>
          </div>
          <v-card
            v-for="(item, index) in itemsForConception"
            :key="index"
            class="inner-card my-4 py-2 px-4"
            :elevation="0"
            :style="
              index % 2 !== 0 && {
                backgroundColor: 'rgba(243, 243, 243, 0.5)',
              }
            "
          >
            <v-row no-gutters class="my-5">
              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("dashboardS.matingDate")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.matingDate || $t("noDataAvailable")
                }}</v-card-text>
              </v-col>

              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("dashboardS.inseminatorName")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.inseminatorName || $t("noDataAvailable")
                }}</v-card-text>
              </v-col>
              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  "dashboardS.orgName"
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.orgName || $t("noDataAvailable")
                }}</v-card-text>
              </v-col>
              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("dashboardS.conceptionMethod")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.orgName || $t("noDataAvailable")
                }}</v-card-text>
              </v-col>
              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("dashboardS.brServiceNum")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.breedingServiceNo || $t("noDataAvailable")
                }}</v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
        <!-----------------End --------------------->
        <v-data-table
          v-else
          :headers="headersForConception"
          :items="indexedItems(itemsForConception)"
          :items-per-page="5"
          hide-default-footer
          :options.sync="tableOptionsConception"
          item-key="id"
          :server-items-length="totalConception"
          :loading="cloading"
        >
          <template v-slot:top>
            <div class="d-flex my-5">
              <p class="mt-2 ml-4 font-weight-bold">
                {{ $t("animal.conception") }}
              </p>

              <v-spacer></v-spacer>
              <div class="py-1 title">
                {{ fromConception }} - {{ toConception }} of
                {{ totalConception }}
              </div>
              <v-btn
                class="mt-1 ml-1"
                icon
                :disabled="tableOptionsConception.page <= 1"
                @click="pageChangeConception(false)"
              >
                <v-icon small> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn
                class="mt-1"
                icon
                :disabled="tableOptionsConception.page >= totalPagesConception"
                @click="pageChangeConception(true)"
              >
                <v-icon small> mdi-chevron-right </v-icon>
              </v-btn>
              <!-- <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="mt-1 mr-1">
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
              </v-menu> -->
            </div>
          </template>
          <template v-slot:[`item.conceptionMethod`]="{ item }">
            {{ item.conceptionMethod.name }}
          </template>
        </v-data-table>
      </v-card>
      <v-card
        class="border rounded-lg mx-9 mb-5"
        elevation="0"
        outlined
        id="semenEmbryoTypeTable"
        v-show="semenEmbryoInfo"
      >
        <!-- <v-card-title>
          Semen/Embryo info
          <v-spacer></v-spacer>
          <v-avatar size="15" color="#DAE1EC"></v-avatar>
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on">
                <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-card-title> -->
        <!--------------------- Tablet Screen For Embryo---------------------->
        <!------------------- Start -------------------->
        <v-card v-if="checkBreakPoints" elevation="0" class="px-5">
          <div class="d-flex my-5">
            <p class="mt-2 ml-4">{{ $t("dashboardS.semEmbInfo") }}</p>
            <v-spacer></v-spacer>
            <div class="py-1 title">
              {{ fromEmbryoInfo }} - {{ toEmbryoInfo }} of
              {{ totalEmbryoInfo }}
            </div>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="tabletTableOptionsEmbryoInfo.page <= 1"
              @click="tabletPageChangeEmbryoInfo(false)"
            >
              <v-icon dark> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="
                tabletTableOptionsEmbryoInfo.page >= totalPagesEmbryoInfo
              "
              @click="tabletPageChangeEmbryoInfo(true)"
            >
              <v-icon dark> mdi-chevron-right </v-icon>
            </v-btn>
          </div>
          <!-- { text: "Mating Date", value: "matingDate" },
        { text: "Sire ID", value: "sire" },
        { text: "Surrogate Dam ID", value: "surrogateDam" },
        { text: "Embryo Org. Name", value: "embryoOrgName" },
        { text: "Surrogate Dam Breed", value: "surrogateDamBreed" },
        { text: "Sire Breed", value: "sireBreed" }, -->
          <v-card
            v-for="(item, index) in itemsForEmbryoInfo"
            :key="index"
            class="inner-card my-4 py-2 px-4"
            :elevation="0"
            :style="
              index % 2 !== 0 && {
                backgroundColor: 'rgba(243, 243, 243, 0.5)',
              }
            "
          >
            <v-row no-gutters class="my-5">
              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("dashboardS.matingDate")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.matingDate || $t("noDataAvailable")
                }}</v-card-text>
              </v-col>

              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("dashboardS.sireId")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.sire && item.sire.animalNumber
                    ? item.sire.animalNumber
                    : $t("noDataAvailable")
                }}</v-card-text>
              </v-col>
              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">
                  {{ $t("dashboardS.srgDamId") }}</v-card-text
                >
                <v-card-text class="py-1 font-weight-bold">{{
                  item.embryoOrgName || $t("noDataAvailable")
                }}</v-card-text>
              </v-col>
              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("dashboardS.embOrgName")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.orgName || $t("noDataAvailable")
                }}</v-card-text>
              </v-col>
              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("dashboardS.srgDamBreed")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  (item.surrogateDamBreed &&
                    item.surrogateDamBreed.animalNumber) ||
                  $t("noDataAvailable")
                }}</v-card-text>
              </v-col>
              <v-col md="4" sm="4">
                <v-card-text style="color: #787878" class="py-1">{{
                  $t("dashboardS.sireBreed")
                }}</v-card-text>
                <v-card-text class="py-1 font-weight-bold">{{
                  item.sireBreed || $t("noDataAvailable")
                }}</v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
        <!-----------------End --------------------->
        <v-data-table
          v-else
          :headers="headersForEmbryoInfo"
          :items="indexedItems(itemsForEmbryoInfo)"
          :items-per-page="5"
          hide-default-footer
          :options.sync="tableOptionsEmbryoInfo"
          item-key="id"
          :server-items-length="totalEmbryoInfo"
          :loading="sloading"
        >
          <template v-slot:top>
            <div class="d-flex my-5">
              <p class="mt-2 ml-4 font-weight-bold">
                {{ $t("dashboardS.semEmbInfo") }}
              </p>
              <v-spacer></v-spacer>
              <div class="py-1 title">
                {{ fromEmbryoInfo }} - {{ toEmbryoInfo }} of
                {{ totalEmbryoInfo }}
              </div>
              <v-btn
                class="mt-1 ml-1"
                icon
                :disabled="tableOptionsEmbryoInfo.page <= 1"
                @click="pageChangeEmbryoInfo(false)"
              >
                <v-icon small> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn
                class="mt-1"
                icon
                :disabled="tableOptionsEmbryoInfo.page >= totalPagesEmbryoInfo"
                @click="pageChangeEmbryoInfo(true)"
              >
                <v-icon small> mdi-chevron-right </v-icon>
              </v-btn>
              <!-- <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="mt-1 mr-1">
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
              </v-menu> -->
            </div>
          </template>
          <template v-slot:[`item.sire`]="{ item }">
            <p class="mt-5">
              {{ item.sire ? item.sire.animalNumber : "" }}
            </p>
            <!-- <br /> -->
            <!-- <p class="mt-n4">
              {{ item.sire ? item.sire.name : "" }}
            </p> -->
          </template>
          <template v-slot:[`item.surrogateDam`]="{ item }">
            <p class="mt-5">
              {{ item.surrogateDam ? item.surrogateDam.animalNumber : "" }}
            </p>
            <!-- <br /> -->
            <p class="mt-n4">
              {{ item.surrogateDam ? item.surrogateDam.name : "" }}
            </p>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import GenoService from "@/_services/GenoService";
import AnimalService from "@/_services/AnimalService";
import GeneralService from "@/_services/GeneralService";

export default {
  async mounted() {
    document.title = this.$t("dashboard");
    this.startLoading();
    setTimeout(() => {
      this.stopLoading();
    }, 1000);

    // document.getElementById("MyElement").classList.add('MyClass');
    let genoTypeTableElement =
      document.getElementById("genoTypeTable").childNodes[0];
    let conceptionTableElement =
      document.getElementById("conceptionTable").childNodes[0];
    let semenEmbryoTypeTableElement = document.getElementById(
      "semenEmbryoTypeTable"
    ).childNodes[0];
    let elements = [
      genoTypeTableElement,
      conceptionTableElement,
      semenEmbryoTypeTableElement,
    ];
    this.changeTableSortIcon(elements);
  },
  components: {},
  created() {
    this.getDashboardStatistics()
    if (this.checkBreakPoints) {
      this.getTabletGenos();
      this.tabletGetAllAnimalConceptionData();
      this.tabletGetAllAnimalEmbryoData();
    }
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  watch: {
    tableOptionsGenotype: {
      handler() {
        this.getGenos();
      },
      deep: true,
    },
    tableOptionsConception: {
      handler() {
        this.getAllAnimalConceptionData();
      },
      deep: true,
    },
    tableOptionsEmbryoInfo: {
      handler() {
        this.getAllAnimalEmbryoData();
      },
      deep: true,
    },
  },
  data() {
    return {
      activitiesCount: 0,
      pendingTasksCount: 0,
      selected: [],
      loading: true,
      ploading: false,
      cloading: false,
      sloading: false,
      menu: false,
      menuSelectionList: [
        "Performance Of Genotypes",
        "Conception",
        "Semen/Embryo Info",
      ],
      genotypeChecked: true,
      conceptionChecked: true,
      embryoInfoChecked: true,
      performanceOfGenotypes: true,
      conception: true,
      semenEmbryoInfo: true,
      headersForGenotype: [
        {
          text: this.$t("dashboardS.breed"),
          value: "breedName",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("dashboardS.chromosome"),
          value: "chromosome",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("dashboardS.seqChange"),
          value: "sequenceChange",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("dashboardS.inheritance"),
          value: "inheritance",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("dashboardS.diseaseName"),
          value: "diseaseName",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("dashboardS.refSequence"),
          value: "referenceSequence",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("dashboardS.pubmedRef"),
          value: "pubmedReference",
          class: "black--text",
          sortable: true,
        },
      ],
      itemsForGenotype: [
        {
          breed: "Senepol",
          chromosome: 20,
          sequenceChange: "g.39099226C>A",
          inheritance: "Dominant",
          diseaseName: "Slick Hair",
          referenceSequence: "ARS-UCD1.2",
          pubmedReference: "29527221",
        },
        {
          breed: "Poll Hereford",
          chromosome: 7,
          sequenceChange: "g.65080197C>A",
          inheritance: "Recessive",
          diseaseName: "Myoclonus",
          referenceSequence: "Bos_taurus_UMD_3.1",
          pubmedReference: "11178872",
        },
      ],

      headersForConception: [
        {
          text: this.$t("dashboardS.matingDate"),
          value: "matingDate",
          class: "black--text",
        },
        {
          text: this.$t("dashboardS.inseminatorName"),
          value: "inseminatorName",
          class: "black--text",
        },
        {
          text: this.$t("dashboardS.orgName"),
          value: "orgName",
          class: "black--text",
        },
        {
          text: this.$t("dashboardS.brServiceNum"),
          value: "breedingServiceNo",
          class: "black--text",
        },
        {
          text: this.$t("dashboardS.conceptionMethod"),
          value: "conceptionMethod",
          class: "black--text",
        },
      ],
      itemsForConception: [
        {
          matingDate: "10/12/2020",
          inseminator: "John Smith",
          organization: "Insem LTD",
          breedingServiceNumber: "72346423",
          conceptionMethod: "Artificial Insemenation",
        },
        {
          matingDate: "30/12/2019",
          inseminator: "Bob Torre",
          organization: "Preg LTD",
          breedingServiceNumber: "72346791",
          conceptionMethod: "Natural Mating",
        },
        {
          matingDate: "01/12/2019",
          inseminator: "John Smith",
          organization: "Embryo LTD",
          breedingServiceNumber: "72478423",
          conceptionMethod: "Embryo Transfer",
        },
      ],

      headersForEmbryoInfo: [
        {
          text: this.$t("dashboardS.matingDate"),
          value: "matingDate",
          class: "black--text",
        },
        {
          text: this.$t("dashboardS.sireId"),
          value: "sire",
          class: "black--text",
        },
        {
          text: this.$t("dashboardS.srgDamId"),
          value: "surrogateDam",
          class: "black--text",
        },
        {
          text: this.$t("dashboardS.embOrgName"),
          value: "embryoOrgName",
          class: "black--text",
        },
        {
          text: this.$t("dashboardS.srgDamBreed"),
          value: "surrogateDamBreed",
          class: "black--text",
        },
        {
          text: this.$t("dashboardS.sireBreed"),
          value: "sireBreed",
          class: "black--text",
        },
      ],
      itemsForEmbryoInfo: [
        {
          matingDate: "10/12/2020",
          sireId: "#SR56784784",
          surrogateDamId: "#SD568958",
          EmbryoOrgName: "Semen LTD",
          surrogateDamBreed: "Holstein",
          sireBreed: "Holstein",
        },
        {
          matingDate: "10/12/2020",
          sireId: "#SR896786",
          surrogateDamId: "#SD34563456",
          EmbryoOrgName: "Semen LTD",
          surrogateDamBreed: "Holstein",
          sireBreed: "Holstein",
        },
        {
          matingDate: "10/12/2020",
          sireId: "#SR3452345",
          surrogateDamId: "#SD568958",
          EmbryoOrgName: "Embryo LTD",
          surrogateDamBreed: "Holstein",
          sireBreed: "Holstein",
        },
      ],

      tableOptionsGenotype: {},
      tabletTableOptionsGenotype: { itemsPerPage: 5, page: 1, sortBy: [] },
      fromGenotype: 0,
      toGenotype: 0,
      totalgenos: 1,
      totalPagesGenotype: 1,

      tableOptionsConception: {},
      tabletTableOptionsConception: { itemsPerPage: 5, page: 1, sortBy: [] },
      fromConception: 0,
      toConception: 0,
      totalConception: 1,
      totalPagesConception: 1,

      tableOptionsEmbryoInfo: {},
      tabletTableOptionsEmbryoInfo: { itemsPerPage: 5, page: 1, sortBy: [] },
      fromEmbryoInfo: 0,
      toEmbryoInfo: 0,
      totalEmbryoInfo: 1,
      totalPagesEmbryoInfo: 1,
    };
  },
  methods: {
    getDashboardStatistics() {
      GeneralService.getDashboardStatistics()
      .then(res => {
        if(res.success){
          this.activitiesCount = res.data.activitiesCount
          this.pendingTasksCount = res.data.pendingTasksCount
        }
      })
      .catch(err => {
        console.log('Error', err)
      })
    },
    resetCardStructure() {
      this.performanceOfGenotypes = this.genotypeChecked;
      this.conception = this.conceptionChecked;
      this.semenEmbryoInfo = this.embryoInfoChecked;
      this.menu = false;
    },
    restoreDefaualtStructure() {
      (this.performanceOfGenotypes = true), (this.genotypeChecked = true);
      (this.conception = true), (this.conceptionChecked = true);
      (this.semenEmbryoInfo = true), (this.embryoInfoChecked = true);
      this.menu = false;
    },
    getGenos() {
      this.ploading = true;
      GenoService.getGenos(this.tableOptionsGenotype, "")
        .then((res) => {
          if (res.success) {
            this.itemsForGenotype = res.data.genotypePerformance.rows;
            // this.currentrows = res.data.genotypePerformance.num_rows;
            this.totalgenos = res.data.genotypePerformance.total_rows;
            // this.pageCount = Math.ceil(
            //   this.totalgenos / this.tableOptionsGenotype.itemsPerPage
            // );
            this.totalPagesGenotype = Math.ceil(
              this.totalgenos / this.tableOptionsGenotype.itemsPerPage
            );
            this.fromGenotype =
              (this.tableOptionsGenotype.page - 1) *
                this.tableOptionsGenotype.itemsPerPage +
              1;
            this.toGenotype =
              this.tableOptionsGenotype.page *
                this.tableOptionsGenotype.itemsPerPage -
              (this.tableOptionsGenotype.itemsPerPage -
                res.data.genotypePerformance.num_rows);
            this.ploading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.ploading = false;
        });
    },
    getTabletGenos() {
      this.loading = true;
      GenoService.getGenos(this.tabletTableOptionsGenotype, "")
        .then((res) => {
          if (res.success) {
            this.itemsForGenotype = res.data.genotypePerformance.rows;
            // this.currentrows = res.data.genotypePerformance.num_rows;
            this.totalgenos = res.data.genotypePerformance.total_rows;
            // this.pageCount = Math.ceil(
            //   this.totalgenos / this.tabletTableOptionsGenotype.itemsPerPage
            // );
            this.totalPagesGenotype = Math.ceil(
              this.totalgenos / this.tabletTableOptionsGenotype.itemsPerPage
            );
            this.fromGenotype =
              (this.tabletTableOptionsGenotype.page - 1) *
                this.tabletTableOptionsGenotype.itemsPerPage +
              1;
            this.toGenotype =
              this.tabletTableOptionsGenotype.page *
                this.tabletTableOptionsGenotype.itemsPerPage -
              (this.tabletTableOptionsGenotype.itemsPerPage -
                res.data.genotypePerformance.num_rows);
            // this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    pageChangeGenoType(t) {
      if (t)
        this.tableOptionsGenotype.page = this.tableOptionsGenotype.page + 1;
      else this.tableOptionsGenotype.page = this.tableOptionsGenotype.page - 1;

      this.getGenos();
    },
    tabletPageChangeGenoType(t) {
      if (t)
        this.tabletTableOptionsGenotype.page =
          this.tabletTableOptionsGenotype.page + 1;
      else
        this.tabletTableOptionsGenotype.page =
          this.tabletTableOptionsGenotype.page - 1;

      this.getTabletGenos();
    },

    getAllAnimalConceptionData() {
      this.cloading = true;
      AnimalService.getAllAnimalSectionData(
        "conception",
        "conception",
        this.tableOptionsConception
      )
        .then((res) => {
          this.itemsForConception = res.data.animalConception.rows;
          this.totalConception = res.data.animalConception.totalRows;
          this.totalPagesConception = Math.ceil(
            this.totalConception / this.tableOptionsConception.itemsPerPage
          );
          this.fromConception =
            (this.tableOptionsConception.page - 1) *
              this.tableOptionsConception.itemsPerPage +
            1;
          this.toConception =
            this.tableOptionsConception.page *
              this.tableOptionsConception.itemsPerPage -
            (this.tableOptionsConception.itemsPerPage -
              res.data.animalConception.numRows);
            this.cloading = false;
        })
        .catch((err) => {
          this.cloading = false;
          console.log(err);
        });
    },
    tabletGetAllAnimalConceptionData() {
      // this.loading = true;
      AnimalService.getAllAnimalSectionData(
        "conception",
        "conception",
        this.tabletTableOptionsConception
      )
        .then((res) => {
          this.itemsForConception = res.data.animalConception.rows;
          this.totalConception = res.data.animalConception.totalRows;
          this.totalPagesConception = Math.ceil(
            this.totalConception /
              this.tabletTableOptionsConception.itemsPerPage
          );
          this.fromConception =
            (this.tabletTableOptionsConception.page - 1) *
              this.tabletTableOptionsConception.itemsPerPage +
            1;
          this.toConception =
            this.tabletTableOptionsConception.page *
              this.tabletTableOptionsConception.itemsPerPage -
            (this.tabletTableOptionsConception.itemsPerPage -
              res.data.animalConception.numRows);
          // this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    pageChangeConception(t) {
      if (t)
        this.tableOptionsConception.page = this.tableOptionsConception.page + 1;
      else
        this.tableOptionsConception.page = this.tableOptionsConception.page - 1;

      this.getAllAnimalConceptionData();
    },
    tabletPageChangeConception(t) {
      if (t)
        this.tabletTableOptionsConception.page =
          this.tabletTableOptionsConception.page + 1;
      else
        this.tabletTableOptionsConception.page =
          this.tabletTableOptionsConception.page - 1;

      this.tabletGetAllAnimalConceptionData();
    },

    getAllAnimalEmbryoData() {
      this.sloading = true;
      AnimalService.getAllAnimalSectionData(
        "conception",
        "semenembryo",
        this.tableOptionsEmbryoInfo
      )
        .then((res) => {
          this.itemsForEmbryoInfo = res.data.animalConception.rows;
          this.totalEmbryoInfo = res.data.animalConception.totalRows;
          this.totalPagesEmbryoInfo = Math.ceil(
            this.totalEmbryoInfo / this.tableOptionsEmbryoInfo.itemsPerPage
          );
          this.fromEmbryoInfo =
            (this.tableOptionsEmbryoInfo.page - 1) *
              this.tableOptionsEmbryoInfo.itemsPerPage +
            1;
          this.toEmbryoInfo =
            this.tableOptionsEmbryoInfo.page *
              this.tableOptionsEmbryoInfo.itemsPerPage -
            (this.tableOptionsEmbryoInfo.itemsPerPage -
              res.data.animalConception.numRows);
          this.sloading = false;
        })
        .catch((err) => {
          this.sloading = false;
          console.log(err);
        });
    },
    tabletGetAllAnimalEmbryoData() {
      this.sloading = true;
      AnimalService.getAllAnimalSectionData(
        "conception",
        "semenembryo",
        this.tabletTableOptionsEmbryoInfo
      )
        .then((res) => {
          this.itemsForEmbryoInfo = res.data.animalConception.rows;
          this.totalEmbryoInfo = res.data.animalConception.totalRows;
          this.totalPagesEmbryoInfo = Math.ceil(
            this.totalEmbryoInfo /
              this.tabletTableOptionsEmbryoInfo.itemsPerPage
          );
          this.fromEmbryoInfo =
            (this.tabletTableOptionsEmbryoInfo.page - 1) *
              this.tabletTableOptionsEmbryoInfo.itemsPerPage +
            1;
          this.toEmbryoInfo =
            this.tabletTableOptionsEmbryoInfo.page *
              this.tabletTableOptionsEmbryoInfo.itemsPerPage -
            (this.tabletTableOptionsEmbryoInfo.itemsPerPage -
              res.data.animalConception.numRows);
            this.sloading = false;
        })
        .catch((err) => {
          this.sloading = false;
          console.log(err);
        });
    },

    pageChangeEmbryoInfo(t) {
      if (t)
        this.tableOptionsEmbryoInfo.page = this.tableOptionsEmbryoInfo.page + 1;
      else
        this.tableOptionsEmbryoInfo.page = this.tableOptionsEmbryoInfo.page - 1;

      this.getAllAnimalEmbryoData();
    },
    tabletPageChangeEmbryoInfo(t) {
      if (t)
        this.tabletTableOptionsEmbryoInfo.page =
          this.tabletTableOptionsEmbryoInfo.page + 1;
      else
        this.tabletTableOptionsEmbryoInfo.page =
          this.tabletTableOptionsEmbryoInfo.page - 1;

      this.tabletGetAllAnimalEmbryoData();
    },

    indexedItems(items) {
      return items.map((item, index) => ({
        id: index,
        ...item,
      }));
    },

    changeTableSortIcon(elements) {
      for (let element of elements) {
        let allTh =
          element.childNodes[1].childNodes[0].childNodes[1].childNodes[0]
            .childNodes;
        let index = 0;
        for (let th of allTh) {
          if (index > 0)
            th.childNodes[1].className =
              "v-icon notranslate v-data-table-header__icon mdi mdi-unfold-more-horizontal theme--light";
          index++;
        }
      }
    },

    // changeSort(column, tableOption) {
    //   if (this[`${tableOption}`].sortBy[0] === column) {
    //     this[`${tableOption}`].descending = !this[`${tableOption}`].descending;
    //     this[`${tableOption}`].sortDesc[0] = !this[`${tableOption}`].descending
    //   } else {
    //     this[`${tableOption}`].sortBy[0] = column;
    //     this[`${tableOption}`].descending = false;
    //     this[`${tableOption}`].sortDesc[0] = false
    //   }

    //   if(tableOption == 'tableOptionsGenotype') {
    //     this.getGenos();
    //   }
    //   else if(tableOption == 'tableOptionsConception')
    //   {
    //     this.getAllAnimalConceptionData();
    //   }
    //   else if(tableOption == 'tableOptionsEmbryoInfo')
    //   {
    //     this.getAllAnimalEmbryoData();
    //   }
    // }
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
.border {
  border: 2px solid;
  border-color: #dae1ec;
}
::v-deep .v-data-table-header th {
  white-space: nowrap;
}
::v-deep .v-data-table-header__icon {
  display: inline-block;
  opacity: 100 !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

::v-deep .v-data-table__wrapper table tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.035) !important;
}
</style>
